define(function(require,module,exports){
	return function(data, req) {
		return data && data.json || JSON.parse((data.text||data.responseText));
	}
});